import React from "react";
import logo from "../../assets/logo.png";
import { useHistory } from "react-router-dom";

const Header = ({navigateToRegistrationForm, loginType, setLoginType}) => {
    const history = useHistory();

    return (
        <nav className="navbar navbar-light w-100 glass">
            <img alt="logo" src={logo} height="50px" width="245px" />
            <div className="d-flex align-items-center">
                <div class="mb-0 link" onClick={() => history.push("/home")} style={{cursor: "pointer"}}><i class="fa fa-long-arrow-left mr-2" aria-hidden="true"></i>Back to Homepage</div>
            </div>
        </nav>
    );
}

export default Header;